import { ReactComponent as AppleColorLight } from 'fym-shared/src/music-services/assets/images/apple-color-light.svg';
import { ReactComponent as AppleColorDark } from 'fym-shared/src/music-services/assets/images/apple-color-dark.svg';
import { ReactComponent as AppleColorLightPadding } from 'fym-shared/src/music-services/assets/images/apple-color-light-padding.svg';
import { ReactComponent as AppleColorDarkPadding } from 'fym-shared/src/music-services/assets/images/apple-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const appleMusicImages: MusicServiceImages = {
  logoColor: {
    light: AppleColorLight,
    dark: AppleColorDark,
  },
  logoColorPadding: {
    light: AppleColorLightPadding,
    dark: AppleColorDarkPadding,
  },
};
